import {
	GET_ADVISORY_AGREEMENT_SUCCESS,
	GET_ADVISORY_SIGNATURE_SUCCESS,
	POST_ADVISORY_SIGNATURE_REACTIVATION_SUCCESS,
} from 'stash/actions/api';

export const initialState = {
	agreements: [],
	signature: {},
};

const advisoryAgreementsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ADVISORY_AGREEMENT_SUCCESS: {
			return {
				...state,
				agreement: action.response.agreement,
				agreements: action.response.agreements || action.response.agreement?.agreements,
				coreDisclosureStatement:
					action.response.coreDisclosureStatement ||
					action.response.agreement?.coreDisclosureStatement,
				disclosureStatement:
					action.response.disclosureStatement ||
					action.response.agreement?.disclosureStatement,
				header: action.response.header || action.response.agreement?.header,
				subheader: action.response.subheader || action.response.agreement?.subheader,
			};
		}
		case GET_ADVISORY_SIGNATURE_SUCCESS:
		case POST_ADVISORY_SIGNATURE_REACTIVATION_SUCCESS: {
			return {
				...state,
				signature: action.response.userEsignature,
			};
		}
		default:
			return state;
	}
};

export default advisoryAgreementsReducer;
